module.exports = __webpack_public_path__ + "img/Loading.e580552f.gif";